import api from "@/services/api";

class DismissPremiumVoucherNotice {
  execute = async () => {
    const response = await api().post("/associate-premium/vouchers/dismiss-notice");
    return response.data;
  };
}

export { DismissPremiumVoucherNotice };
